import { gql } from '@apollo/client';

export * from './auditLogs.query.generated';

export const AUDIT_LOGS = gql`
  query auditLogs($eventTypes: [String!], $createdAfter: ISO8601Date, $page: Int, $perPage: Int) {
    auditLogs(eventTypes: $eventTypes, createdAfter: $createdAfter, page: $page, perPage: $perPage) {
      nodes {
        id
        createdAt
        source
        eventType
        payload
        parentId
        parentType
        user {
          id
          name
        }
      }
      hasNextPage
      hasPreviousPage
      nodesCount
      pagesCount
    }
  }
`;
